import React from 'react';
import { createPortal } from 'react-dom';
import './index.scss';

/**
 * 微信内打开时，引导用户「在浏览器中打开」的蒙层。
 * 用户端注册、后台登录/注册等页面共用。
 */
const WechatBrowserTip = ({ visible, onClose }) => {
  if (!visible) return null;

  const overlay = (
    <div className="wechat-browser-tip-overlay" onClick={onClose}>
      <div className="wechat-browser-tip-arrow" />
      <div className="wechat-browser-tip-content" onClick={(e) => e.stopPropagation()}>
        <div className="wechat-browser-tip-title">请在浏览器中打开</div>
        <div className="wechat-browser-tip-text">
          点击右上角 <span>···</span>
        </div>
        <div className="wechat-browser-tip-text">
          选择 <span>在浏览器中打开</span>
        </div>
        <div className="wechat-browser-tip-hint">点击任意位置关闭</div>
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
};

export default WechatBrowserTip;
